<template>
  <div class="container">
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/jobs/vessel-it-support-executive"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Vessel-IT-Support-Executive.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Vessel IT Support Executive
                </h2>
              </strong>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <br />
    <v-hover v-slot="{ hover }" open-delay="100">
      <v-card
        height="100%"
        :elevation="hover ? 16 : 2"
        :class="{ 'on-hover': hover }"
        to="/jobs/remote-marketing-executive"
      >
        <v-row justify="center" class="pt-4">
          <v-col sm="12" md="4" lg="4">
            <v-list-item three-line>
              <v-list-item-content>
                <v-img
                  :src="require('@/assets/Remote-Marketing-Executive.webp')"
                  class="mx-auto"
                  width="300px"
                  height="200px"
                />
                <v-list-item-subtitle /> <br />
                <v-list-item-subtitle> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col sm="12" md="8" lg="8">
            <p style="padding: 20px; text-align: justify">
              <strong>
                <h2>
                  Remote Marketing Executive (Maritime Industry)
                </h2>
              </strong>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
.jo-class {
  text-align: justify;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}
@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
